var _defs, _g, _g2, _tspan, _tspan2, _g3, _g4, _tspan3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg18",
    width: 493.04791,
    height: 1025.4836,
    viewBox: "0 0 493.04791 1025.4836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 331.55,758.938 c -95.81,-0.017 -199.752,-0.023 -295.563,0.008 v 0 c -3.88,10e-4 -7.567,-0.699 -11.153,-2.076 v 0 C 15.958,753.583 10.787,744.197 10.931,734.999 v 0 C 10.932,596.008 10.91,457.017 10.946,318.027 v 0 c 0.282,-94.548 -0.533,-189.149 0.265,-283.67 v 0 C 12.183,27.025 15.795,19.778 22.85,16.705 v 0 c 3.858,-1.836 7.967,-2.692 12.263,-2.69 v 0 c 31.081,0.016 62.162,0.011 93.242,0.01 v 0 c 64.978,-0.002 138.089,0.003 203.067,-0.026 v 0 c 4.372,-0.001 8.548,0.711 12.573,2.426 v 0 c 9,3.613 12.712,13.518 12.625,22.647 v 0 c -0.037,115.701 0.007,231.402 -0.008,347.104 v 0 c -1.099,118.728 2.137,237.918 -1.152,356.428 v 0 c -2.614,10.34 -12.869,16.345 -23.158,16.345 v 0 c -0.251,0 -0.501,-0.003 -0.752,-0.011",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.0212,749.189 H 336.954 V 731.893 H 28.0212 Z",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 315.018,747.365 h 21.936 v -11.163 h -21.936 z",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 255.63,746.782 h 2.782 v -10.859 h -2.782 z",
    id: "path52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,769.113 H 369.786 V 0 H 0 Z",
    id: "path188"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1.3333333,0,0,-1.3333333,-5.9619648e-5,1025.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    clipPath: "url(#clipPath34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 356.619,47.771 H 10.931 v 686.105 h 345.688 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 356.615,725.177 H 9.361 v 34.898 h 347.254 z",
    style: {
      fill: "#334651",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath46)",
    opacity: 0.699997,
    id: "g112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath50)",
    opacity: 0.410004,
    id: "g62"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.942,736.2023)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -17.585 c -0.739,0 -1.339,0.599 -1.339,1.339 v 8.485 c 0,0.74 0.6,1.339 1.339,1.339 H 0 c 0.739,0 1.339,-0.599 1.339,-1.339 V 8.173 H 3.012 V 2.811 H 1.339 V 1.339 C 1.339,0.599 0.739,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.6144,737.6738)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 8.22 C 0,8.703 0.391,9.094 0.874,9.094 H 11.316 V -0.874 H 0.874 C 0.391,-0.874 0,-0.483 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1,0,0,-1,28.0215,736.0537)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "15.3543px",
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto-Regular",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text74"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 8.621439 12.33718 20.95862",
    y: 0,
    id: "tspan72"
  }, "9:41"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1,0,0,-1,286.7954,737.0537)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto-Regular",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text78"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.868 15.736",
    y: 0,
    id: "tspan76"
  }, "64%"))), /*#__PURE__*/React.createElement("path", {
    d: "m 250.377,735.923 h -2.782 v 6.264 h 2.782 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 254.395,735.923 h -2.782 v 8.552 h 2.782 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath54)",
    opacity: 0.410004,
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 258.412,735.923 h -2.782 v 10.859 h 2.782 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m 246.415,735.923 h -2.782 v 4.276 h 2.782 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.7759,745.1354)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.371,-1.45 c -0.593,0.58 -1.252,1.068 -1.977,1.45 -1.397,0.791 -3.018,1.239 -4.732,1.239 -1.713,0 -3.334,-0.448 -4.731,-1.239 -0.725,-0.382 -1.384,-0.87 -1.978,-1.45 L -16.159,0 h 0.013 c 2.109,2.003 4.943,3.216 8.066,3.216 3.124,0 5.958,-1.213 8.067,-3.216 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.5617,742.7893)",
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.358,-1.437 c -1.173,1.121 -2.754,1.806 -4.507,1.806 -1.753,0 -3.335,-0.685 -4.508,-1.806 L -11.731,0 c 1.529,1.463 3.599,2.346 5.866,2.346 h 0.052 C -3.559,2.333 -1.516,1.45 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.3869,740.4827)",
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.344,-1.424 c -0.62,0.58 -1.45,0.936 -2.346,0.936 -0.897,0 -1.727,-0.356 -2.333,-0.936 L -7.381,0 C -6.419,0.936 -5.114,1.489 -3.69,1.489 -2.267,1.489 -0.962,0.936 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.1725,738.1497)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -1.476,-1.568 -2.952,0 c 0.369,0.369 0.896,0.593 1.476,0.593 C -0.896,0.593 -0.369,0.369 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(192.4015,36.0394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.022,4.946 -3.525,8.563 -8.422,8.588 -4.944,0.025 -8.557,-3.526 -8.579,-8.431 -0.023,-4.953 3.516,-8.557 8.422,-8.579 C -3.626,-8.445 -0.022,-4.906 0,0 m -101.048,-0.04 c 0,2.177 0.064,4.356 -0.018,6.53 -0.085,2.286 -1.352,3.115 -3.288,2.045 -3.808,-2.106 -7.575,-4.294 -11.276,-6.582 -1.804,-1.115 -1.797,-2.64 0.014,-3.758 3.702,-2.286 7.467,-4.477 11.276,-6.58 1.931,-1.067 3.189,-0.228 3.276,2.067 0.078,2.09 0.016,4.185 0.016,6.278 M 91.963,-7.872 c 1.836,0 3.674,0.056 5.507,-0.016 1.845,-0.072 2.526,0.76 2.493,2.557 -0.068,3.67 -0.046,7.343 -0.011,11.015 0.014,1.524 -0.537,2.359 -2.174,2.347 C 93.939,8.002 90.1,8.001 86.262,8.033 84.661,8.047 84.018,7.302 84.033,5.74 c 0.036,-3.755 0.046,-7.512 -0.006,-11.266 -0.024,-1.731 0.757,-2.407 2.428,-2.358 1.835,0.055 3.672,0.013 5.508,0.012 m -281.35,32.068 H 172.386 V -24.04 h -361.773 z",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(284.2336,30.0037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -5.954,0 -5.954,0 -5.954,5.96 0,6.268 0,6.268 6.148,6.268 6.079,0 6.079,0 6.08,-6.086 C 6.274,0 6.274,0 0,0",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(89.3404,29.0929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -4.113,2.411 -7.738,4.537 -11.97,7.017 -7.723,9.51 -4.055,11.663 0,14.043 Z",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "translate(183.9665,29.4315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.847,-0.024 -6.715,2.758 -6.759,6.558 -0.045,3.852 2.719,6.753 6.502,6.823 3.96,0.072 6.888,-2.774 6.884,-6.692 C 6.623,2.852 3.822,0.024 0,0",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g132",
    transform: "translate(284.2336,30.0037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.274,0 6.274,0 6.274,6.142 -0.001,6.086 -0.001,6.086 -6.08,6.086 -6.148,0 -6.148,0 -6.148,-6.268 C -5.954,0 -5.954,0 0,0 m 0.131,-1.836 c -1.836,0 -3.673,0.042 -5.508,-0.012 -1.671,-0.05 -2.452,0.626 -2.428,2.357 0.052,3.755 0.042,7.511 0.006,11.266 -0.015,1.563 0.628,2.307 2.228,2.294 C -1.732,14.037 2.107,14.038 5.946,14.067 7.583,14.079 8.134,13.243 8.12,11.72 8.085,8.048 8.063,4.375 8.131,0.704 8.164,-1.092 7.483,-1.924 5.638,-1.852 3.805,-1.78 1.967,-1.836 0.131,-1.836",
    style: {
      fill: "#757575",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g136",
    transform: "translate(89.3404,29.0929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 14.043 C -4.055,11.663 -7.723,9.51 -11.97,7.017 -7.738,4.537 -4.113,2.411 0,0 M 2.013,6.907 C 2.013,4.814 2.075,2.718 1.997,0.628 1.91,-1.667 0.652,-2.505 -1.278,-1.439 c -3.809,2.104 -7.575,4.294 -11.277,6.58 -1.811,1.119 -1.817,2.644 -0.014,3.758 3.701,2.288 7.468,4.477 11.276,6.582 1.936,1.071 3.203,0.242 3.289,-2.044 0.081,-2.174 0.017,-4.353 0.017,-6.53",
    style: {
      fill: "#757575",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g140",
    transform: "translate(183.9665,29.4315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 3.822,0.024 6.623,2.852 6.627,6.689 6.631,10.607 3.703,13.453 -0.257,13.381 -4.04,13.311 -6.804,10.41 -6.759,6.558 -6.715,2.758 -3.847,-0.024 0,0 M 8.435,6.608 C 8.413,1.702 4.809,-1.837 -0.144,-1.814 -5.05,-1.792 -8.589,1.812 -8.566,6.765 -8.544,11.67 -4.931,15.22 0.013,15.196 4.91,15.171 8.457,11.554 8.435,6.608",
    style: {
      fill: "#757575",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g170",
    transform: "translate(193.5147,460.2762)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g186",
    clipPath: "url(#clipPath190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g192",
    transform: "translate(356.6128,386.1756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.099,118.728 2.136,237.919 -1.154,356.428 -2.677,10.593 -13.372,16.636 -23.909,16.335 -95.81,-0.017 -199.752,-0.023 -295.562,0.007 -3.88,0.001 -7.568,-0.699 -11.154,-2.075 -8.876,-3.287 -14.046,-12.673 -13.903,-21.872 0.002,-138.99 -0.021,-277.981 0.015,-416.972 0.283,-94.547 -0.533,-189.148 0.266,-283.67 0.971,-7.331 4.583,-14.578 11.638,-17.651 3.859,-1.837 7.968,-2.693 12.264,-2.69 31.081,0.015 62.161,0.01 93.241,0.009 64.979,-10e-4 138.089,0.004 203.068,-0.025 4.372,-0.002 8.547,0.71 12.573,2.425 8.999,3.614 12.711,13.519 12.624,22.647 C -0.03,-231.403 0.014,-115.701 0,0 m 10.814,116.865 c 0.23,-0.264 0.312,-0.441 0.444,-0.497 1.61,-0.676 1.917,-1.972 1.914,-3.568 -0.028,-14.946 -0.014,-29.892 -0.013,-44.838 0.006,-1.118 -0.001,-2.401 -1.097,-3.044 -1.438,-0.853 -1.78,-2.23 -1.803,-3.758 -0.007,-136.624 -0.016,-273.248 0.003,-409.873 -0.329,-4.427 -1.143,-8.827 -2.276,-13.128 -2.758,-8.621 -9.114,-15.938 -17.384,-19.604 -4.496,-2.213 -9.344,-3.068 -14.245,-3.608 -1.729,-0.596 -3.488,-0.663 -5.284,-0.663 -97.477,1.421 -202.95,-2.796 -300.139,1.619 -10.366,2.626 -19.978,9.292 -23.826,19.624 -1.825,4.911 -3.035,9.908 -2.835,15.194 -1.616,28.621 -0.461,57.471 -0.785,86.196 0.004,199.168 -0.122,398.336 -0.003,597.504 -0.113,2.534 0.777,4.948 0.847,7.466 -0.024,6.02 -0.063,12.072 2.193,17.749 2.559,8.066 8.271,15.118 16.2,18.375 3.282,2.091 7.015,2.907 10.722,3.788 1.518,0.176 3.084,-0.17 4.548,0.513 95.446,1.38 199.068,-0.032 294.622,0.493 1.911,0.328 3.647,-0.755 5.474,-0.869 5.672,0.079 10.886,-2.434 15.861,-4.885 1.434,-0.719 2.777,-1.7 3.994,-2.755 3.141,-2.526 5.441,-5.73 7.373,-9.239 0.833,-1.734 2.196,-3.25 2.222,-5.323 0.002,-0.153 0.083,-0.318 0.165,-0.454 1.313,-2.17 1.342,-4.636 1.637,-7.041 0.326,-2.419 1.111,-4.724 0.917,-7.205 0.093,-25.333 0.075,-50.665 -0.004,-75.998 0.34,-2.06 -0.947,-5.954 1.419,-6.98 1.052,-0.44 1.354,-1.35 1.437,-2.357 0.13,-26.881 0.006,-53.772 0.051,-80.657 0,-4.223 -0.002,-8.447 -0.003,-12.671 10e-4,-1.467 0.213,-3.111 -1.304,-3.909 -1.607,-0.922 -1.422,-2.787 -1.435,-4.368 0.215,-13.7 -0.5,-27.575 0.393,-41.229",
    style: {
      fill: "#353535",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g196",
    transform: "translate(193.5446,741.7396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.581,-4.506 -4.102,-9.186 -8.68,-8.596 -4.482,-0.509 -8.72,3.954 -8.668,8.481 0.06,5.179 3.968,8.794 8.664,8.868 C -4.347,8.821 0.497,4.988 0,0",
    style: {
      fill: "#353535",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 209.461,126.166 H 356.614 V 59.636 H 209.461 Z",
    style: {
      fill: "#334651",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#f8b218",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path200"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1,0,0,-1,253.0034,82.623)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "23.7273px",
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto-Regular",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text204"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.047008 20.737659 33.574131 41.92614 55.426971 61.785889",
    y: 0,
    id: "tspan202"
  }, "Install")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid1);
export default __webpack_public_path__ + "static/media/android1.d6c18336781c8a7d02a5002ba16ac874.svg";
export { ForwardRef as ReactComponent };